import React from 'react';
import PropTypes from 'prop-types';
import { LifeBuoy } from 'lucide-react';
import { getConfig } from '@edx/frontend-platform';

/**
 * IGEA: Small footer card shown under the modules accordion.
 *
 * Layout:
 *   - Two compact metadata rows (total lessons + modules count)
 *   - A support CTA linking to the help centre configured in env.
 *
 * All colours are inline to survive edX's global cascade (same reason
 * as IgeaModuleAccordion).
 */
const IgeaSidebarFooter = ({ totalLessons, totalModules, supportUrl }) => {
  const resolvedSupportUrl = supportUrl
    || getConfig().SUPPORT_URL
    || 'https://www.igeacps.it/assistenza';

  return (
    <div
      className="tw-px-4 tw-py-3"
      style={{ fontSize: '12px', color: '#6B7280' }}
    >
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
        <span>Lezioni totali</span>
        <span style={{ fontWeight: 600, color: '#1F2937' }}>
          {totalLessons}
        </span>
      </div>
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-3">
        <span>Moduli</span>
        <span style={{ fontWeight: 600, color: '#1F2937' }}>
          {totalModules}
        </span>
      </div>
      <a
        href={resolvedSupportUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="tw-flex tw-items-center tw-gap-2 tw-pt-3 tw-border-t tw-border-igea-border tw-no-underline"
        style={{ fontSize: '13px', fontWeight: 500, color: '#7C3AED' }}
      >
        <LifeBuoy size={14} strokeWidth={2} />
        <span>Hai bisogno di aiuto?</span>
      </a>
    </div>
  );
};

IgeaSidebarFooter.propTypes = {
  totalLessons: PropTypes.number,
  totalModules: PropTypes.number,
  supportUrl: PropTypes.string,
};

IgeaSidebarFooter.defaultProps = {
  totalLessons: 0,
  totalModules: 0,
  supportUrl: '',
};

export default IgeaSidebarFooter;
